import * as React from 'react';
export const IcSmokeSensor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.61 16.77a1.002 1.002 0 00-1.22-1.59 4 4 0 01-4.78 0 1.002 1.002 0 10-1.22 1.59 5.91 5.91 0 007.22 0zM17.33 18a8 8 0 01-10.66 0 1.002 1.002 0 00-1.34 1.49 10 10 0 0013.34 0A1.002 1.002 0 0017.33 18zm2.43-15.6A1.002 1.002 0 0019 2H5a1 1 0 00-.76.35 1 1 0 00-.24.81l.86 5.17a2 2 0 002 1.67h.43l.54 1.63A2 2 0 009.72 13h4.56a2 2 0 001.9-1.37l.54-1.63h.43a2 2 0 002-1.67L20 3.16a1.001 1.001 0 00-.24-.81v.05z'
      fill='currentColor'
    />
  </svg>
);
